export default __webpack_public_path__ + "images/acfc00ff70e8c1c021e6fa87e7a52e53.png";